import React, { useMemo, useState } from "react";
import { useAppSelector } from "@/services/hooks";
import { ToastContainer } from "react-toastify";

import DisplayPagesView from "./DisplayPagesView";
import usePageDeleteConfirm from "../usePageDeleteConfirm";

const DisplayPagesContainer = () => {
  const CurrentSite = useAppSelector((s) => s.sites.site) || {};
  const pagesTotal = useAppSelector((s) => s.pages.list?.total) || 0;

  const [displaySimplePages, setDisplaySimplePages] = useState(true);

  // SCRUM-1811: this screen no longer dispatches getSitesByDomain on mount. That
  // call fetched the site's pages 50 at a time only for the table, which now
  // asks GET /api/pages for one page itself (PagesContainer). The site document
  // this screen still reads — required_pages — is loaded at app start
  // (App.jsx) and refreshed by the write thunks that change it.

  const resultNavFooter = useMemo(() => {
    const rp = CurrentSite.required_pages || [];
    if (rp.length === 0) return 0;
    if (rp.length === 1) return 1;
    if (rp.length === 2) return 2;
    return "...";
  }, [CurrentSite.required_pages]);

  // The server's count of the pages the table lists (chips and search applied).
  const resultPages = pagesTotal;

  // The confirm dialog and the delete behind it (moved to a hook for SCRUM-2021,
  // so the Create Page screen asks the same question).
  const { confirmDelete, confirmElement } = usePageDeleteConfirm();

  return (
    <>
      <div className="rna-wrapper">
        <ToastContainer />
      </div>
      {confirmElement}
      <DisplayPagesView
        displaySimplePages={displaySimplePages}
        setDisplaySimplePages={setDisplaySimplePages}
        resultPages={resultPages}
        resultNavFooter={resultNavFooter}
        CurrentSite={CurrentSite}
        deletePageOperation={confirmDelete}
      />
    </>
  );
};

export default DisplayPagesContainer;
